export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4649.97c5ec2b.jpg";